import DOMPurify from 'dompurify';

/** Sanitize Rich Text for use */
const sanitize = (html = '') => DOMPurify?.sanitize(html);

/** Get only the text from Rich Text */
const getText = (html = '') => DOMPurify?.sanitize(html, { ALLOWED_TAGS: ['#text'] });

export { getText, sanitize };
